import { getTestAttributes, slug } from '@chillibean/component-library';
import PropTypes from 'prop-types';

function RadioField(props) {
  const {
    disabled,
    handleChange,
    handleBlur,
    handleClick,
    fieldID,
    optionValue,
    optionText,
    fieldIdentifier = 'radio',
    fieldName,
    selectedOption,
  } = props;

  const handleOnChange = (event) => handleChange && handleChange(event, 'radio');
  const handleOnBlur = (event) => handleBlur && handleBlur(event, 'radio');
  const handleOnClick = (event) => handleClick && handleClick(event);

  return (
    <>
      <div className="form__field form__options-grid-child">
        <input
          type="radio"
          name={fieldName}
          id={`${fieldID}`}
          data-test-id={`field_${fieldID}`}
          className="form__control form__control--radio"
          onClick={handleOnClick}
          onBlur={(event) => handleOnBlur(event)}
          onChange={(event) => handleOnChange(event)}
          disabled={disabled}
          value={optionValue}
          checked={optionValue === selectedOption}
        />

        <label htmlFor={`${fieldID}`} {...getTestAttributes(`${slug(`${optionValue}-${fieldIdentifier}`)}-form-field`)}>
          {optionText && <span>{optionText}</span>}
        </label>
      </div>
    </>
  );
}

RadioField.propTypes = {
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleClick: PropTypes.func,
  fieldID: PropTypes.string,
  optionValue: PropTypes.string,
  optionText: PropTypes.string,
  fieldIdentifier: PropTypes.string,
  fieldName: PropTypes.string,
  selectedOption: PropTypes.string,
  options: PropTypes.array,
  showError: PropTypes.bool,
  errorMessage: PropTypes.string,
  fieldRequired: PropTypes.bool,
};

export default RadioField;
